import { h, Fragment } from "preact";

import { BillingPeriod } from "../../../foundation/enums";
import classname from "../../../foundation/utils/classname";
import RadioButton from "../../v2/RadioButton";

import styles from "./BillingPeriodChooser.module.css";

interface Props {
    selectedBillingPeriod: BillingPeriod;
    onBillingPeriodChange: (event: Event) => void;
    annualDiscountText: string;
    annualCaption: string;
    monthlyCaption: string;
}

export default function BillingPeriodChooser({
    selectedBillingPeriod,
    onBillingPeriodChange,
    annualDiscountText,
    annualCaption,
    monthlyCaption
}: Props) {
    return (
        <div class={styles.billingPeriodChooserContainer}>
            <div class={classname("body-1 medium", styles.header)}>Billing period</div>
            <div class={styles.billingPeriodChooser}>
                <label>
                    <RadioButton
                        class={styles.radioButton}
                        value={BillingPeriod.ANNUALLY}
                        checked={selectedBillingPeriod === BillingPeriod.ANNUALLY}
                        name="billingPeriod"
                        onChange={onBillingPeriodChange}/>
                    <div class={styles.period}>
                        <p class="body-1 medium">Annually — <span class={styles.offText}>{annualDiscountText}</span></p>
                        <p class="caption-1">{annualCaption}</p>
                    </div>
                </label>
                <label>
                    <RadioButton
                        class={styles.radioButton}
                        value={BillingPeriod.MONTHLY}
                        checked={selectedBillingPeriod === BillingPeriod.MONTHLY}
                        name="billingPeriod"
                        onChange={onBillingPeriodChange}/>
                    <div className={styles.period}>
                        <p className="body-1 medium">Monthly</p>
                        <p className="caption-1">{monthlyCaption}</p>
                    </div>
                </label>
            </div>
        </div>
    );
}
